import { getFeatureFlags } from 'services';
import {
  isFrenchPlatform,
  isSpanishPlatform,
  isItalianPlatform,
} from 'utils/isPlatform';

const B2B_GLOBAL_FEATURE_FLAG = 'ff.global.b2b';

export function isPro() {
  return (
    window.manomano?.user?.isB2B &&
    getFeatureFlags()[B2B_GLOBAL_FEATURE_FLAG] === 'ON' &&
    (isFrenchPlatform() || isSpanishPlatform() || isItalianPlatform())
  );
}
